import { connect }            from 'react-redux';

import Home from './Home';

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/app/components/Views/Home/index.js